import api from '../axios';

/**
 * InvitationService — API calls for the invitation system.
 * Maps to: /invitations/* backend routes.
 */
const InvitationService = {
  /**
   * POST /invitations
   * Send a new invitation to a user by email.
   */
  send: (invitedEmail, role = 'user') =>
    api.post('/invitations', {
      invited_email: invitedEmail,
      status: 'pending',
      role,
    }),

  /**
   * GET /invitations/incoming
   * Get all pending invitations received by the current user.
   */
  getIncoming: () => api.get('/invitations/incoming'),

  /**
   * GET /invitations/sent
   * Get all invitations sent by the current user.
   */
  getSent: () => api.get('/invitations/sent'),

  /**
   * PATCH /invitations/:id/accept
   * Accept a specific invitation.
   */
  accept: (invitationId) => api.patch(`/invitations/${invitationId}/accept`),

  /**
   * POST /invitations/reject-all
   * Reject all incoming invitations for the current user.
   */
  rejectAll: () => api.post('/invitations/reject-all'),

  /**
   * POST /invitations/:id/cancel
   * Cancel a sent invitation.
   */
  cancel: (invitationId) => api.post(`/invitations/${invitationId}/cancel`),
};

export default InvitationService;
